import React, { FC } from 'react';
import SwipePager, {
  type SwipePagerProps,
  type SwipePageMeta,
} from '../../../../shared/SwipePager/SwipePager';
import { isWeatherDaySwipeIgnoredTarget } from '../../helpers/day/daySwipe';

export type DaySwipePageMeta = SwipePageMeta;

export type DaySwipePagerProps = Omit<
  SwipePagerProps,
  'syncScroll' | 'isIgnoredTarget' | 'getPageTestId'
>;

const DaySwipePager: FC<DaySwipePagerProps> = (props) => (
  <SwipePager
    {...props}
    syncScroll
    isIgnoredTarget={isWeatherDaySwipeIgnoredTarget}
    getPageTestId={(slot) => `weather-forecast-day-swipe-${slot}`}
  />
);

export default DaySwipePager;
